import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { DocPackTypeSubmitEvent } from '../doc-pack-type.component';
import { GetDocPackTypeParams } from '@app/services/doc-pack-type.service';

@Component({
    selector: 'tt-doc-pack-type-view',
    templateUrl: './doc-pack-type-view.component.html',
    styleUrls: ['./doc-pack-type-view.component.css'],
})
export class DocPackTypeViewComponent {
    public params: GetDocPackTypeParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as GetDocPackTypeParams;
    }

    public onSubmit(event: DocPackTypeSubmitEvent) {
        if (event.type === 'save') {
            this.state.go('docpacktypemenu', `${event.docpacktype_keyno}`, { location: 'replace' });
        } else if (event.type === 'delete') {
            this.state.back();
        }
    }
}
